/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ExchangeManagementUser
 */
export interface ExchangeManagementUser {
    /**
     * 유저 uuid
     * @type {string}
     * @memberof ExchangeManagementUser
     */
    'userUuid': string;
    /**
     * 아이디
     * @type {string}
     * @memberof ExchangeManagementUser
     */
    'id': string;
    /**
     * 이름
     * @type {string}
     * @memberof ExchangeManagementUser
     */
    'name': string;
    /**
     * 생년월일
     * @type {string}
     * @memberof ExchangeManagementUser
     */
    'birthdate': string;
    /**
     * 주민등록번호 뒷자리
     * @type {string}
     * @memberof ExchangeManagementUser
     */
    'rrn'?: string;
    /**
     * 유저 레벨
     * @type {string}
     * @memberof ExchangeManagementUser
     */
    'level'?: ExchangeManagementUserLevelEnum;
}

export const ExchangeManagementUserLevelEnum = {
    Baby: 'baby',
    Friends: 'friends',
    Family: 'family',
    Supporters: 'supporters',
    Guardian: 'guardian',
    Both: 'both'
} as const;

export type ExchangeManagementUserLevelEnum = typeof ExchangeManagementUserLevelEnum[keyof typeof ExchangeManagementUserLevelEnum];


